/**
 * Clones an object and removes addions like reactivity.
 * This is intended for cloning data objects from Vue instances.
 */
export function cloneDeepClean<T>(object: T): T {
    return JSON.parse(JSON.stringify(object));
}
